import { render, staticRenderFns } from "./VisitsTable.vue?vue&type=template&id=1bb930ec&scoped=true&"
import script from "./VisitsTable.vue?vue&type=script&lang=js&"
export * from "./VisitsTable.vue?vue&type=script&lang=js&"
import style0 from "./VisitsTable.vue?vue&type=style&index=0&id=1bb930ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb930ec",
  null
  
)

export default component.exports